import React from 'react'
import { TimeSeriesRow } from 'common/types'
import { IDs } from 'common/consts'
import { SplitImageLayer } from 'components/layers/SplitImageLayer'
import { convertCoordinates } from 'common/utils'

export type RainSplitLayerProps = {
  rain: TimeSeriesRow | null
  opacity: number
}

export const KouzuiKikikuruWideLayer = ({rain, opacity}: RainSplitLayerProps) => {

  const visibility = React.useMemo((): boolean => rain !== null, [rain])

  const coordinates = convertCoordinates([
    [48, 118],
    [20, 150]
  ])

  return (
    <>
      <SplitImageLayer
        url={rain ? rain.url : null}
        coordinates={coordinates}
        sourceId={IDs.rainfall.wideSource}
        layerId={IDs.rainfall.wideLayer}
        splitNum={5}
        opacity={opacity}
        visibility={visibility}
      />
    </>
  )
}
